var map = {
	"./demo/qa-preprod-web": [
		40750,
		750
	],
	"./nz/qa-preprod-web": [
		31520,
		520
	],
	"./pmi/qa-preprod-web": [
		60708,
		415
	],
	"./uat/qa-preprod-web": [
		29835,
		835
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5822;
module.exports = webpackAsyncContext;